// V2 Block Configuration (2026.1.0)
// This file defines all blocks available in version 2026.1.0
// Based on V1 with specific V2 updates

// AppActions blocks
import SnapActionNavigate from "../v1/blocks/AppActions/SnapActionNavigate";
import SnapActionNavigateBack from "../v1/blocks/AppActions/NavigateBack";
import SnapActionValidate from "../v1/blocks/AppActions/ValidatePage";
import SetFocus from "../v1/blocks/AppActions/SetFocus";
import ReloadCurrentPage from "../v1/blocks/AppActions/ReloadCurrentPage";
import ReloadPage from "../v1/blocks/AppActions/ReloadPage";
import OpenApp from "../v1/blocks/AppActions/OpenApp";
import OpenSnapApp from "../v1/blocks/AppActions/OpenSnapApp";
import CloseApp from "../v1/blocks/AppActions/CloseApp";
import SnapActionOpenBrowser from "../v1/blocks/AppActions/OpenBrowser";
import DisplayPageGridview from "./blocks/AppActions/DisplayPageGridview";

// AppActions blocks
import SnapActionResetPage from '../v1/blocks/AppActions/ResetPage';
import SnapActionSubmit from '../v1/blocks/AppActions/Submit';
import SnapActionSync from '../v1/blocks/AppActions/Sync';

// All other blocks use V1 versions (unchanged)
// Colour blocks
import ColourPicker from '../v1/blocks/Colour/ColourPicker';
import ColourRGB from '../v1/blocks/Colour/ColourRGB';

// Connections block
import RestServiceV2 from '../v2/blocks/Connections/RestService';

// Dates blocks
import DateBlock from '../v1/blocks/Dates/DateBlock';
import Today from '../v1/blocks/Dates/Today';
import GetDayFromDate from '../v1/blocks/Dates/GetDayFromDate';
import AddToDate from '../v1/blocks/Dates/AddToDate';
import DatePickerNumber from '../v1/blocks/Dates/DatePickerNumber';
import DateIsBefore from '../v1/blocks/Dates/DateIsBefore';
import GetDaysApart from '../v1/blocks/Dates/GetDaysApart';

// Debug blocks
import Log from '../v1/blocks/Debug/Log';
import LogInfo from '../v1/blocks/Debug/LogInfo';
import LogError from '../v1/blocks/Debug/LogError';

// Global Variables blocks
import GetEnvironmentVariable from '../v1/blocks/Variables/GetEnvironmentVariable';
import SetEnvironmentVariable from '../v1/blocks/Variables/SetEnvironmentVariable';

// Lists blocks
import {
    ListsCreateWith,
    ListsGetIndex, 
    ListsGetSublist,
    ListsIndexOf,
    ListsIsEmpty,
    ListsLength,
    ListsRepeat, 
    ListsSort, 
    ListsSplit
} from '../v1/blocks/Lists/BlocklyBlocks';
import ListsSetIndex2 from '../v1/blocks/Lists/ListsSetIndex2';
import MakeJSONWith from '../v1/blocks/Lists/MakeJSONWith';
import GetFromJSON from '../v1/blocks/Lists/GetFromJSON';
import GetFromJSONWithSchema from '../v1/blocks/Lists/GetFromJSONWithSchema';
import UpdateJSON from '../v1/blocks/Lists/UpdateJSON';
import StringifyJSON from '../v1/blocks/Lists/StringifyJSON';

// Logic blocks
import ControlsIf from '../v1/blocks/Logic/ControlsIf';
import LogicBoolean from '../v1/blocks/Logic/LogicBoolean';
import LogicCompareNew from '../v1/blocks/Logic/LogicCompareNew';
import LogicNegate from '../v1/blocks/Logic/LogicNegate';
import LogicNull from '../v1/blocks/Logic/LogicNull';
import LogicOperation from '../v1/blocks/Logic/LogicOperation';
import SnapWait from '../v1/blocks/Logic/SnapWait';

// Loops blocks
import ControlsFlowStatements from '../v1/blocks/Loops/ControlsFlowStatements';
import ControlsRepeat from '../v1/blocks/Loops/ControlsRepeat';
import ControlsWhileUntil from '../v1/blocks/Loops/ControlsWhileUntil';
import CountWith from '../v1/blocks/Loops/CountWith';
import ForEachItemInList from '../v1/blocks/Loops/ForEachItemInList';

// Math blocks
import {
    MathNumber,
    MathArithmetic,
    MathSingle,
    MathTrig,
    MathConstant,
    MathNumberProperty,
    MathRound,
    MathModulo,
    MathConstrain,
    MathRandomInt,
    MathRandomFloat,
    MathOnList
} from '../v1/blocks/Math/MathBlocks';
import RoundToDecimal from '../v1/blocks/Math/RoundToDecimal';
import MathToNumber from '../v1/blocks/Math/MathToNumber';

// MobiControl blocks
import MobiControlGetAndroidDeviceDetails from '../v1/blocks/MobiControl/GetAndroidDeviceDetails';
import MobiControlGetCustomAttribute from '../v1/blocks/MobiControl/GetCustomAttribute';
import MobiControlGetIsEnrolled from '../v1/blocks/MobiControl/GetIsEnrolled';
import MobiControlGetDeviceId from '../v1/blocks/MobiControl/GetDeviceId';
import MobiControlGetIpAddress from '../v1/blocks/MobiControl/GetIpAddress';
import MobiControlGetMacAddress from '../v1/blocks/MobiControl/GetMacAddress';
import MobiControlGetSerialNumber from '../v1/blocks/MobiControl/GetSerialNumber';
import MobiControlGetIosDeviceDetails from '../v1/blocks/MobiControl/GetIosDeviceDetails';

// Repeater blocks
import RepeaterNavigateFirst from '../v1/blocks/Repeater/RepeaterNavigateFirst';
import RepeaterNavigateBack from '../v1/blocks/Repeater/RepeaterNavigateBack';
import RepeaterNavigateNext from '../v1/blocks/Repeater/RepeaterNavigateNext';
import RepeaterNavigateLast from '../v1/blocks/Repeater/RepeaterNavigateLast';
import RepeaterNavigateTo from '../v1/blocks/Repeater/RepeaterNavigateTo';
import RepeaterEntryNew from '../v1/blocks/Repeater/RepeaterEntryNew';
import RepeaterEntryDelete from '../v1/blocks/Repeater/RepeaterEntryDelete';
import RepeaterEntrySave from '../v1/blocks/Repeater/RepeaterEntrySave';
import RepeaterEntriesAmount from '../v1/blocks/Repeater/RepeaterEntriesAmount';
import RepeaterEntryIndex from '../v1/blocks/Repeater/RepeaterEntryIndex';
import RepeaterEntryValue from '../v1/blocks/Repeater/RepeaterEntryValue';
import RepeaterEntryIndexValue from '../v1/blocks/Repeater/RepeaterEntryIndexValue';

// Sound blocks
import PlayNote from '../v1/blocks/Sound/PlayNote';
import PlayBeep from '../v1/blocks/Sound/PlayBeeps';

// Table blocks
import SelectedRow from '../v1/blocks/Table/SelectedRow';
import AddRow from '../v1/blocks/Table/AddRow';
import GetRecords from '../v1/blocks/Table/GetRecords';
import SetColumnName from '../v1/blocks/Table/SetColumnName';
import GetColumn from '../v1/blocks/Table/GetColumn';
import DeleteRow from '../v1/blocks/Table/DeleteRow';
import UpdateRow from '../v1/blocks/Table/UpdateRow';
import RefreshTable from '../v1/blocks/Table/RefreshTable';
import RunEditRecords from '../v1/blocks/Table/RunEditRecords';
import CancelEditRecords from '../v1/blocks/Table/CancelEditRecords';
import ShowHideRow from '../v1/blocks/Table/ShowHideRow';
import LoadTableDataRestV2 from '../v2/blocks/Table/LoadTableDataRest';

// Text blocks
import {
    Text,
    TextJoin,
    TextAppend,
    TextLength,
    TextIsEmpty,
    TextIndexOf,
    TextCharAt,
    TextGetSubstring,
    TextChangeCase,
    TextTrim
} from '../v1/blocks/Text/BlocklyBlocks';
import SotiSnackbar from '../v1/blocks/Text/SotiSnackbar';
import ShowMessage from '../v1/blocks/Text/ShowMessage';
import ShowPrompt from '../v1/blocks/Text/ShowPrompt';
import Confirm from '../v1/blocks/Text/Confirm';
import TextRegex from '../v1/blocks/Text/TextRegex';

// XSight Topics blocks
import GetXSightTopic from '../v1/blocks/XSightTopics/GetXSightTopic';
import SetXSightTopic from '../v1/blocks/XSightTopics/SetXSightTopic';

// Widget Values - Barcode blocks
import Barcode from '../v1/blocks/WidgetValues/Barcode';
import GetScannedValues from '../v1/blocks/WidgetValues/Barcode/GetScannedValues';

// Widget Values - BusinessCard blocks
import BusinessCard from '../v1/blocks/WidgetValues/BusinessCard';
import GetBusinessCardValue from '../v1/blocks/WidgetValues/BusinessCard/GetBusinessCardValue';
import SetBusinessCardValue from '../v1/blocks/WidgetValues/BusinessCard/SetBusinessCardValue';

// Widget Values - Camera blocks
import Camera from '../v2/blocks/WidgetValues/Camera';
import CameraReset from '../v2/blocks/WidgetValues/Camera/CameraReset';

// Widget Values - GroupList blocks
import GroupList from '../v1/blocks/WidgetValues/GroupList';
import GetGroupList from '../v1/blocks/WidgetValues/GroupList/GetGroupList';

// Widget Values - Hamburger blocks
import Hamburger from '../v1/blocks/WidgetValues/Hamburger';
import SetHamburgerToPage from '../v1/blocks/WidgetValues/Hamburger/SetHamburgerToPage';
import GetHamburgerName from '../v1/blocks/WidgetValues/Hamburger/GetHamburgerName';
import SetHamburgerName from '../v1/blocks/WidgetValues/Hamburger/SetHamburgerName';
import GetHamburgerImage from '../v1/blocks/WidgetValues/Hamburger/GetHamburgerImage';
import SetHamburgerImage from '../v1/blocks/WidgetValues/Hamburger/SetHamburgerImage';

// Widget Values - Button blocks
import Button from '../v1/blocks/WidgetValues/Button';
import SetButtonDisplayText from '../v1/blocks/WidgetValues/Button/SetButtonDisplayText';

// Widget Values - CheckboxList blocks
import CheckboxList from '../v1/blocks/WidgetValues/CheckboxList';
import SetCheckboxlistOption from '../v1/blocks/WidgetValues/CheckboxList/SetCheckboxlistOption';
import InCheckboxlistCheckboxIsChecked from '../v1/blocks/WidgetValues/CheckboxList/InCheckboxlistCheckboxIsChecked';
import GetCheckboxlistSelectedCheckboxes from '../v1/blocks/WidgetValues/CheckboxList/GetCheckboxlistSelectedCheckboxes';

// Widget Values - Chart blocks
import Charts from '../v1/blocks/WidgetValues/Chart';
import RefreshChart from '../v1/blocks/WidgetValues/Chart/RefreshChart';

// Widget Values - Date blocks
import Dates from '../v1/blocks/WidgetValues/Date';
import GetDateValue from '../v1/blocks/WidgetValues/Date/GetDateValue';
import SetDateValue from '../v1/blocks/WidgetValues/Date/SetDateValue';
import ClearDateValue from '../v1/blocks/WidgetValues/Date/ClearDateValue';
import SetDatePlaceholderText from '../v1/blocks/WidgetValues/Date/SetDatePlaceholderText';

// Widget Values - Dropdown blocks
import Dropdown from '../v1/blocks/WidgetValues/Dropdown';
import AddDropdownOption from '../v1/blocks/WidgetValues/Dropdown/AddDropdownOption';
import SetDropdown from '../v1/blocks/WidgetValues/Dropdown/SetDropdown';
import GetSelectedValueOfDropdown from '../v1/blocks/WidgetValues/Dropdown/GetSelectedValueOfDropdown';
import DropdownIsSetTo from '../v1/blocks/WidgetValues/Dropdown/DropdownIsSetTo';
import RemoveDropdownOption from "../v2/blocks/WidgetValues/Dropdown/RemoveDropdownOption";

// Widget Values - ExternalData blocks (dynamicdropdown)
import ExternalData from '../v1/blocks/WidgetValues/ExternalData';
import GetExternalDataColumn from '../v1/blocks/WidgetValues/ExternalData/GetExternalDataColumn';

// Widget Values - FileUpload blocks
import FileUpload from '../v1/blocks/WidgetValues/FileUpload';
import GetUploadedValue from '../v1/blocks/WidgetValues/FileUpload/GetUploadedValue';
import GetUploadedValues from '../v1/blocks/WidgetValues/FileUpload/GetUploadedValues';
import ClearFileUpload from '../v1/blocks/WidgetValues/FileUpload/ClearFileUpload';

// Widget Values - FlipSwitch blocks
import FlipSwitch from '../v1/blocks/WidgetValues/FlipSwitch';
import GetFlipSwitchValue from '../v1/blocks/WidgetValues/FlipSwitch/GetFlipSwitchValue';
import SetFlipSwitchValue from '../v1/blocks/WidgetValues/FlipSwitch/SetFlipSwitchValue';

// Widget Values - Image blocks
import Image from '../v1/blocks/WidgetValues/Image';
import GetImageSource from '../v1/blocks/WidgetValues/Image/GetImageSource';
import SetImageSource from '../v1/blocks/WidgetValues/Image/SetImageSource';

// Widget Values - Label blocks
import Label from '../v1/blocks/WidgetValues/Label';
import GetLabelText from '../v1/blocks/WidgetValues/Label/GetLabelText';
import SetLabelText from '../v1/blocks/WidgetValues/Label/SetLabelText';

// Widget Values - Layout blocks
import Layout from '../v1/blocks/WidgetValues/Layout';
import SetLayoutBackgroundColour from '../v1/blocks/WidgetValues/Layout/SetLayoutBackgroundColour';

// Widget Values - Map blocks
import Map from '../v1/blocks/WidgetValues/Map';
import AddMarker from '../v1/blocks/WidgetValues/Map/AddMarker';
import RemoveMarker from '../v1/blocks/WidgetValues/Map/RemoveMarker';
import SetMapZoom from '../v1/blocks/WidgetValues/Map/SetMapZoom';

// Widget Values - Paragraph blocks
import Paragraph from '../v1/blocks/WidgetValues/Paragraph';
import GetParagraphText from '../v1/blocks/WidgetValues/Paragraph/GetParagraphText';
import SetParagraphText from '../v1/blocks/WidgetValues/Paragraph/SetParagraphText';
import SetParagraphColour from '../v1/blocks/WidgetValues/Paragraph/SetParagraphColour';

// Widget Values - RadiobuttonList blocks
import RadioButtonList from '../v1/blocks/WidgetValues/RadiobuttonList';
import SetRadiobuttonList from '../v1/blocks/WidgetValues/RadiobuttonList/SetRadiobuttonList';
import GetValueOfSelectedRadiobutton from '../v1/blocks/WidgetValues/RadiobuttonList/GetValueOfSelectedRadiobutton';
import RadiobuttonListIsSetTo from '../v1/blocks/WidgetValues/RadiobuttonList/RadiobuttonListIsSetTo';

// Widget Values - Rating blocks
import Rating from '../v1/blocks/WidgetValues/Rating';
import GetRating from '../v1/blocks/WidgetValues/Rating/GetRating';
import SetRating from '../v1/blocks/WidgetValues/Rating/SetRating';

// Widget Values - Section blocks
import Section from '../v1/blocks/WidgetValues/Section';
import SetSectionBackgroundColour from '../v1/blocks/WidgetValues/Section/SetSectionBackgroundColour';

// Widget Values - Signature blocks
import Signature from '../v2/blocks/WidgetValues/Signature';
import SignatureReset from '../v2/blocks/WidgetValues/Signature/SignatureReset';

// Widget Values - Textbox blocks
import Textbox from '../v1/blocks/WidgetValues/Textbox';
import GetTextboxValue from '../v1/blocks/WidgetValues/Textbox/GetTextboxValue';
import SetTextboxValue from '../v1/blocks/WidgetValues/Textbox/SetTextboxValue';
import SetTextboxColour from '../v1/blocks/WidgetValues/Textbox/SetTextboxColour';
import SetTextboxPlaceholderText from '../v1/blocks/WidgetValues/Textbox/SetTextboxPlaceholderText';

// Widget Values - Timer blocks
import Timer from '../v1/blocks/WidgetValues/Timer';
import StartTimer from '../v1/blocks/WidgetValues/Timer/startTimer';
import StopTimer from '../v1/blocks/WidgetValues/Timer/stopTimer';
import ResetTimer from '../v1/blocks/WidgetValues/Timer/resetTimer';
import GetTimerValue from '../v1/blocks/WidgetValues/Timer/getTimer';

// Widget Values - User blocks
import User from '../v1/blocks/WidgetValues/User';
import GetUserLoggedIn from '../v1/blocks/WidgetValues/User/GetUserLoggedIn';
import GetUserField from '../v1/blocks/WidgetValues/User/GetUserField';
import GetUserId from '../v1/blocks/WidgetValues/User/GetUserId';
import GetUserFirstName from '../v1/blocks/WidgetValues/User/GetUserFirstName';
import GetUserLastName from '../v1/blocks/WidgetValues/User/GetUserLastName';
import GetUserFullName from '../v1/blocks/WidgetValues/User/GetUserFullName';
import GetUserEmail from '../v1/blocks/WidgetValues/User/GetUserEmail';
import GetUserSystemId from '../v1/blocks/WidgetValues/User/GetUserSystemId';

// Widget Values - UserList blocks
import UserList from '../v1/blocks/WidgetValues/UserList';
import GetUserList from '../v1/blocks/WidgetValues/UserList/GetUserList';
import GetSecretKeyValue from "./blocks/Connections/GetSecretKeyValue";

/**
 * V2 Block Configuration (2026.1.0)
 * Contains mix of V1 (unchanged) and V2 (updated) blocks
 * Only blocks that changed are imported from V2, rest use V1 versions
 */
export const blocksV2 = {
    "Widget Values": {
        'barcode': {
            component: Barcode,
            searchTags: [],
            childComponents: {
                'GetScannedValues': {
                    component: GetScannedValues,
                    searchTags: ["barcode", "scan", "scanner", "scanned", "values", "get", "list", "widget"]
                }
            }
        },
        'businesscard': {
            component: BusinessCard,
            searchTags: [],
            childComponents: {
                'GetBusinessCardValue': {
                    component: GetBusinessCardValue,
                    searchTags: ["get", "business", "businesscard", "BusinessCard", "card", "reader", "value", "field", "name", "title", "email", "phone", "company", "widget"]
                },
                'SetBusinessCardValue': {
                    component: SetBusinessCardValue,
                    searchTags: ["set", "business", "businesscard", "BusinessCard", "card", "reader", "value", "field", "name", "title", "email", "phone", "company", "widget", "to"]
                }
            }
        },
        'button': {
            component: Button,
            searchTags: [],
            childComponents: {
                'SetButtonDisplayText': {
                    component: SetButtonDisplayText,
                    searchTags: ["set", "button", "display", "text", "widget", "to", "values"]
                }
            }
        },
        'camera': {
            component: Camera,
            searchTags: [],
            childComponents: {
                'CameraReset': {
                    component: CameraReset,
                    searchTags: ["reset", "camera", "widget"]
                }
            }
        },
        'checkboxlist': {
            component: CheckboxList,
            searchTags: [],
            childComponents: {
                'SetCheckboxlistOption': {
                    component: SetCheckboxlistOption,
                    searchTags: ["set", "checkbox", "list", "option", "in", "to", "with", "text", "value", "widget", "values"]
                },
                'InCheckboxlistCheckboxIsChecked': {
                    component: InCheckboxlistCheckboxIsChecked,
                    searchTags: ["in", "checkbox", "list", "is", "checked", "widget", "values"]
                },
                'GetCheckboxlistSelectedCheckboxes': {
                    component: GetCheckboxlistSelectedCheckboxes,
                    searchTags: ["get", "checkbox", "list", "selected", "values", "text", "and", "csv", "checkboxes", "widget", "values", "of", "checked", "options", "in", "as"]
                }
            }
        },
        'chart': {
            component: Charts,
            searchTags: [],
            childComponents: {
                'RefreshChart': {
                    component: RefreshChart,
                    searchTags: ["chart", "refresh", "change"]
                }
            }
        },
        'date': {
            component: Dates,
            searchTags: [],
            childComponents: {
                'GetDateValue': {
                    component: GetDateValue,
                    searchTags: ["get", "date", "value", "widget", "values"]
                },
                'SetDateValue': {
                    component: SetDateValue,
                    searchTags: ["set", "date", "value", "widget", "values", "to"]
                },
                'ClearDateValue': {
                    component: ClearDateValue,
                    searchTags: ["clear", "date", "reset", "values", "to"]
                },
                'SetDatePlaceholderText': {
                    component: SetDatePlaceholderText,
                    searchTags: ["set", "date", "placeholder", "text", "widget", "values", "to"]
                }
            }
        },
        'dropdown': {
            component: Dropdown,
            searchTags: [],
            childComponents: {
                'AddDropdownOption': {
                    component: AddDropdownOption,
                    searchTags: ["add", "dropdown", "option", "text", "value", "to", "widget", "values"]
                },
                 'RemoveDropdownOption' : {
                    component: RemoveDropdownOption,
                    searchTags: ["dropdown", "remove", "from", "option", "widget", "values"]
                },
                'SetDropdown': {
                    component: SetDropdown,
                    searchTags: ["set", "dropdown", "option", "text", "value", "to", "by", "list", "widget", "values"]
                },
                'GetSelectedValueOfDropdown': {
                    component: GetSelectedValueOfDropdown,
                    searchTags: ["get", "value", "text", "of", "selected", "dropdown", "option", "in", "widget", "values"]
                },
                'DropdownIsSetTo': {
                    component: DropdownIsSetTo,
                    searchTags: ["dropdown", "option", "is", "set", "to", "widget", "values"]
                }
            }
        },
        'dynamicdropdown': {
            component: ExternalData,
            searchTags: [],
            childComponents: {
                'GetExternalDataColumn': {
                    component: GetExternalDataColumn,
                    searchTags: ["get", "external", "data", "column", "value"]
                }
            }
        },
        'grouplist': {
            component: GroupList,
            searchTags: [],
            childComponents: {
                'GetGroupList': {
                    component: GetGroupList,
                    searchTags: ["get", "group", "list", "selected", "value", "groups", "widget"]
                }
            }
        },
        'hamburger': {
            component: Hamburger,
            searchTags: [],
            childComponents: {
                'SetHamburgerToPage': {
                    component: SetHamburgerToPage,
                    searchTags: ["set", "hamburger", "menu", "page", "screen", "enabled", "disable", "widget"]
                },
                'GetHamburgerName': {
                    component: GetHamburgerName,
                    searchTags: ["get", "hamburger", "name", "widget", "values"]
                },
                'SetHamburgerName': {
                    component: SetHamburgerName,
                    searchTags: ["set", "hamburger", "name", "widget", "values"]
                },
                'GetHamburgerImage': {
                    component: GetHamburgerImage,
                    searchTags: ["get", "hamburger", "image", "widget", "values"]
                },
                'SetHamburgerImage': {
                    component: SetHamburgerImage,
                    searchTags: ["set", "hamburger", "image", "widget", "values"]
                }
            }
        },
        'fileupload': {
            component: FileUpload,
            searchTags: [],
            childComponents: {
                'GetUploadedValue': {
                    component: GetUploadedValue,
                    searchTags: ["get", "upload", "uploaded", "value", "file", "src", "source", "widget", "values", "single"]
                },
                'GetUploadedValues': {
                    component: GetUploadedValues,
                    searchTags: ["get", "upload", "uploaded", "value", "file", "src", "source", "widget", "values", "multiple"]
                },
                'ClearFileUpload': {
                    component: ClearFileUpload,
                    searchTags: ["clear", "remove", "delete", "reset", "upload", "uploaded", "value", "file", "src", "source", "widget", "values"]
                }
            }
        },
        'switch': {
            component: FlipSwitch,
            searchTags: [],
            childComponents: {
                'GetFlipSwitchValue': {
                    component: GetFlipSwitchValue,
                    searchTags: ["get", "flipswitch", "switch", "value", "widget", "values"]
                },
                'SetFlipSwitchValue': {
                    component: SetFlipSwitchValue,
                    searchTags: ["set", "flipswitch", "switch", "value", "widget", "values"]
                }
            }
        },
        'image': {
            component: Image,
            searchTags: [],
            childComponents: {
                'GetImageSource': {
                    component: GetImageSource,
                    searchTags: ["get", "image", "picture", "value", "src", "source", "url", "base64", "widget", "values"]
                },
                'SetImageSource': {
                    component: SetImageSource,
                    searchTags: ["set", "image", "picture", "value", "src", "source", "url", "base64", "to", "widget", "values"]
                }
            }
        },
        'label': {
            component: Label,
            searchTags: [],
            childComponents: {
                'GetLabelText': {
                    component: GetLabelText,
                    searchTags: ["get", "label", "text", "widget", "values"]
                },
                'SetLabelText': {
                    component: SetLabelText,
                    searchTags: ["set", "label", "text", "widget", "values", "to"]
                }
            }
        },
        'layout': {
            component: Layout,
            searchTags: [],
            childComponents: {
                'SetLayoutBackgroundColour': {
                    component: SetLayoutBackgroundColour,
                    searchTags: ["set", "layout", "background", "colour", "color", "to", "widget", "values"]
                }
            }
        },
        'map': {
            component: Map,
            searchTags: [],
            childComponents: {
                'AddMarker': {
                    component: AddMarker,
                    searchTags: ["add", "map", "marker", "latitude", "longitude", "widget", "values"]
                },
                'RemoveMarker': {
                    component: RemoveMarker,
                    searchTags: ["remove", "map", "marker", "widget", "values"]
                },
                'SetMapZoom': {
                    component: SetMapZoom,
                    searchTags: ["set", "map", "zoom", "widget", "values"]
                }
            }
        },
        'paragraph': {
            component: Paragraph,
            searchTags: [],
            childComponents: {
                'GetParagraphText': {
                    component: GetParagraphText,
                    searchTags: ["get", "paragraph", "text", "widget", "values"]
                },
                'SetParagraphText': {
                    component: SetParagraphText,
                    searchTags: ["set", "paragraph", "text", "widget", "values", "to"]
                },
                'SetParagraphColour': {
                    component: SetParagraphColour,
                    searchTags: ["set", "paragraph", "text", "colour", "color", "widget", "values", "to"]
                }
            }
        },
        'radiobuttonlist': {
            component: RadioButtonList,
            searchTags: [],
            childComponents: {
                'SetRadiobuttonList': {
                    component: SetRadiobuttonList,
                    searchTags: ["set", "radio", "button", "text", "value", "to", "by", "text", "list", "widget", "values"]
                },
                'GetValueOfSelectedRadiobutton': {
                    component: GetValueOfSelectedRadiobutton,
                    searchTags: ["get", "value", "text", "of", "selected", "radio", "button", "in", "widget", "values"]
                },
                'RadiobuttonListIsSetTo': {
                    component: RadiobuttonListIsSetTo,
                    searchTags: ["radio", "button", "list", "is", "set", "to", "widget", "values"]
                }
            }
        },
        'rating': {
            component: Rating,
            searchTags: [],
            childComponents: {
                'GetRating': {
                    component: GetRating,
                    searchTags: ["get", "rating", "widget", "values"]
                },
                'SetRating': {
                    component: SetRating,
                    searchTags: ["set", "rating", "to", "widget", "values"]
                }
            }
        },
        'section': {
            component: Section,
            searchTags: [],
            childComponents: {
                'SetSectionBackgroundColour': {
                    component: SetSectionBackgroundColour,
                    searchTags: ["set", "section", "background", "colour", "color", "widget", "values", "to"]
                }
            }
        },
        'signature': {
            component: Signature,
            searchTags: [],
            childComponents: {
                'SignatureReset': {
                    component: SignatureReset,
                    searchTags: ["reset", "signature", "widget"]
                }
            }
        },
        'textbox': {
            component: Textbox,
            searchTags: [],
            childComponents: {
                'GetTextboxValue': {
                    component: GetTextboxValue,
                    searchTags: ["get", "textbox", "value", "widget", "values"]
                },
                'SetTextboxValue': {
                    component: SetTextboxValue,
                    searchTags: ["set", "textbox", "value", "to", "widget", "values"]
                },
                'SetTextboxColour': {
                    component: SetTextboxColour,
                    searchTags: ["set", "textbox", "colour", "background", "text", "color", "to", "widget", "values"]
                },
                'SetTextboxPlaceholderText': {
                    component: SetTextboxPlaceholderText,
                    searchTags: ["set", "textbox", "placeholder", "text", "to", "widget", "values"]
                }
            }
        },
        'timer': {
            component: Timer,
            searchTags: [],
            childComponents: {
                'StartTimer': {
                    component: StartTimer,
                    searchTags: ["timer", "start", "change", "widget", "values"]
                },
                'StopTimer': {
                    component: StopTimer,
                    searchTags: ["timer", "stop", "change", "widget", "values"]
                },
                'ResetTimer': {
                    component: ResetTimer,
                    searchTags: ["timer", "reset", "change", "reset", "widget", "values"]
                },
                'GetTimerValue': {
                    component: GetTimerValue,
                    searchTags: ["timer", "get", "value", "seconds", "format", "widget", "values"]
                }
            }
        },
        'user': {
            component: User,
            searchTags: [],
            childComponents: {
                'GetUserLoggedIn': {
                    component: GetUserLoggedIn,
                    searchTags: ["get", "user", "logged", "in", "value"]
                },
                'GetUserField': {
                    component: GetUserField,
                    searchTags: ["get", "user", "value", "first", "last", "full", "name", "email", "system", "id"]
                },
                'GetUserId': {
                    component: GetUserId,
                    searchTags: ["get", "user", "id", "value"]
                },
                'GetUserFirstName': {
                    component: GetUserFirstName,
                    searchTags: ["get", "user", "first", "name", "value"]
                },
                'GetUserLastName': {
                    component: GetUserLastName,
                    searchTags: ["get", "user", "last", "name", "value"]
                },
                'GetUserFullName': {
                    component: GetUserFullName,
                    searchTags: ["get", "user", "full", "name", "value"]
                },
                'GetUserEmail': {
                    component: GetUserEmail,
                    searchTags: ["get", "user", "email", "value"]
                },
                'GetUserSystemId': {
                    component: GetUserSystemId,
                    searchTags: ["get", "user", "system", "id", "value"]
                }
            }
        },
        'userlist': {
            component: UserList,
            searchTags: [],
            childComponents: {
                'GetUserList': {
                    component: GetUserList,
                    searchTags: ["get", "user", "list", "selected", "value", "widget"]
                }
            }
        }
    },
    "App Actions": {
        CloseApp: {
            component: CloseApp,
            searchTags: ["close", "quit", "app", "exit", "actions"]
        },
        DisplayPageGridview: {
            component: DisplayPageGridview,
            searchTags: ["display", "page", "in", "gridview", "window", "screen", "set", "change", "switch", "show", "layout"]
        },
        SnapActionNavigate: {
            component: SnapActionNavigate,
            searchTags: ["navigate", "page", "screen", "app", "actions"]
        },
        SnapActionNavigateBack: {
            component: SnapActionNavigateBack,
            searchTags: ["navigate", "back", "app", "actions", "previous", "redirect"]
        },
        // V1 blocks (V2 demo blocks removed)
        SnapActionResetPage: {
            component: SnapActionResetPage,
            searchTags: ["reset", "page", "form", "screen", "fields", "unset", "empty", "app", "actions"]
        },
        SnapActionSubmit: {
            component: SnapActionSubmit,
            searchTags: ["submit", "form", "fields", "save", "app", "actions"]
        },
        SnapActionSync: {
            component: SnapActionSync,
            searchTags: ["sync", "form", "fields", "save", "app", "actions"]
        },
        SnapActionValidate: {
            component: SnapActionValidate,
            searchTags: ["page", "form", "fields", "validate", "app", "actions", "required"]
        },
        SnapActionOpenBrowser: {
            component: SnapActionOpenBrowser,
            searchTags: ["navigate", "open", "browser", "url", "web", "internet", "os", "surf", "query", "string"]
        },
        SetFocus: {
            component: SetFocus,
            searchTags: ["page", "form", "set", "focus", "in", "actions"]
        },
        ReloadCurrentPage: {
            component: ReloadCurrentPage,
            searchTags: ["reload", "refresh", "current", "page", "load", "onload", "event", "trigger", "screen", "app", "action"]
        },
        ReloadPage: {
            component: ReloadPage,
            searchTags: ["reload", "refresh", "page", "load", "onload", "event", "trigger", "screen", "app", "action"]
        },
        OpenApp: {
            component: OpenApp,
            searchTags: ["open", "app" , "action"]
        },
        OpenSnapApp: {
            component: OpenSnapApp,
            searchTags: ["open", "app" , "action" , "snap"]
        }
    },
    "Colour": {
        ColourPicker: {
            component: ColourPicker,
            searchTags: ["colour", "color", "red", "blue", "green", "picker", "colors", "colours", "palette"]
        },
        ColourRGB: {
            component: ColourRGB,
            searchTags: ["colour", "color", "red", "blue", "green", "rgb", "colors", "colours", "hex"]
        }
    },
    "Connections": {
        GetSecretKeyValue: {
            component: GetSecretKeyValue,
            searchTags: ["get", "secret", "key", "api", "credentials", "password", "parameter", "hidden", "masked", "connection", "value"]
        },
        RestService: {
            component: RestServiceV2,
            searchTags: ["simple", "rest", "service", "get", "put", "post", "delete", "headers", "api", "connections"]
        }
    },
    "Dates": {
        DateBlock: {
            component: DateBlock,
            searchTags: ["dates", "date", "picker", "datepicker"]
        },
        Today: {
            component: Today,
            searchTags: ["dates", "date", "today"]
        },
        GetDayFromDate: {
            component: GetDayFromDate,
            searchTags: ["get", "dates", "date", "day", "month", "year", "from", "picker", "datepicker"]
        },
        AddToDate: {
            component: AddToDate,
            searchTags: ["dates", "date", "days", "months", "years", "add", "to", "subtract", "1234567890"]
        },
        DatePickerNumber: {
            component: DatePickerNumber,
            searchTags: ["dates", "date", "create", "day", "month", "year"]
        },
        DateIsBefore: {
            component: DateIsBefore,
            searchTags: ["dates", "date", "is", "before", "after", "same", "date", "as", "datepicker", "picker", "comparison", "compare"]
        },
        GetDaysApart: {
            component: GetDaysApart,
            searchTags: ["dates", "get", "days", "apart", "between", "days", "months", "years", "comparison", "compare"]
        }
    },
    "Debug Tools": {
        Log: {
            component: Log,
            searchTags: ["log", "debug", "tools"]
        },
        LogInfo: {
            component: LogInfo,
            searchTags: ["log", "info", "debug", "tools"]
        },
        LogError: {
            component: LogError,
            searchTags: ["log", "error", "debug", "tools"]
        }
    },
    "Global Variables": {
        SetEnvironmentVariable: {
            component: SetEnvironmentVariable,
            searchTags: ["set", "environment", "variable", "to", "import", "export", "data", "external data"]
        },
        GetEnvironmentVariable: {
            component: GetEnvironmentVariable,
            searchTags: ["get", "environment", "variable", "import", "export", "data", "external data"]
        }
    },
    "Lists": {
        ListsCreateWith: {
            component: ListsCreateWith,
            searchTags: ["create", "lists", "with", "()", "[]", "array", "sequence", "dictionary"]
        },
        ListsRepeat: {
            component: ListsRepeat,
            searchTags: ["repeat", "create", "lists", "with", "item", "()", "[]", "array", "sequence", "dictionary"]
        },
        ListsLength: {
            component: ListsLength,
            searchTags: ["lists", "with", "items", "array", "sequence", "dictionary", "length", "count", "of"]
        },
        ListsIsEmpty: {
            component: ListsIsEmpty,
            searchTags: ["lists", "with", "items", "array", "sequence", "dictionary", "count", "empty", "none", "null", "nothing", "undefined", "is"]
        },
        ListsIndexOf: {
            component: ListsIndexOf,
            searchTags: ["lists", "with", "items", "array", "sequence", "dictionary", "first", "last", "occurrence", "exists", "has", "contains", "includes", "find", "first", "last", "occurence", "of", "item"]
        },
        ListsGetIndex: {
            component: ListsGetIndex,
            searchTags: ["lists", "with", "items", "array", "sequence", "dictionary", "first", "last", "occurrence", "1234567890", "index", "position", "at", "remove", "delete", "get", "#", "random", "from", "end", "start", "get", "and", "remove", "first", "end", "random", "hash"]
        },
        ListsSetIndex2: {
            component: ListsSetIndex2,
            searchTags: ["lists", "with", "items", "array", "sequence", "dictionary", "first", "last", "occurrence", "1234567890", "index", "position", "at", "#", "random", "from", "end", "start", "set", "insert", "variables", "as"]
        },
        ListsGetSublist: {
            component: ListsGetSublist,
            searchTags: ["lists", "with", "items", "array", "sequence", "dictionary", "1234567890", "index", "position", "at", "#", "random", "from", "end", "start", "index", "portion", "sub", "partial", "get", "sub", "list", "from", "to", "end", "from", "first", "last"]
        },
        ListsSplit: {
            component: ListsSplit,
            searchTags: ["lists", "with", "items", "array", "sequence", "dictionary", "string", "text", "delimiter", "make", "text", "from", "split", ",-+={}|/;'!@#$%^&*()_+=-1234567890<>?:[]~"]
        },
        ListsSort: {
            component: ListsSort,
            searchTags: ["lists", "with", "items", "array", "sequence", "dictionary", "sort", "ascending", "descending", "numeric", "arrange", "alphabetic", "ignore", "case", "numeric"]
        },
        MakeJSONWith: {
            component: MakeJSONWith,
            searchTags: ["lists", "with", "array", "sequence", "dictionary", "json", "objects", "parse", "{}[]", "key", "value", "create", "make"]
        },
        GetFromJSON: {
            component: GetFromJSON,
            searchTags: ["lists", "with", "array", "sequence", "dictionary", "json", "objects", "parse", "{}[]", "key", "value", "get", "from"]
        },
        GetFromJSONWithSchema: {
            component: GetFromJSONWithSchema,
            searchTags: ["lists", "with", "array", "sequence", "dictionary", "json", "objects", "parse", "{}[]", "key", "value", "get", "from", "schema"]
        },
        UpdateJSON: {
            component: UpdateJSON,
            searchTags: ["lists", "with", "array", "sequence", "dictionary", "json", "objects", "parse", "{}[]", "key", "value", "set", "to", "update"]
        },
        StringifyJSON: {
            component: StringifyJSON,
            searchTags: ["lists", "stringify", "json", "convert", "objects", "to", "text", "{}[]"]
        }
    },
    "Logic": {
        ControlsIf: {
            component: ControlsIf,
            searchTags: ["if", "compare", "logic", "comparison", "greater", "lesser", "equals", "this", "then", "that", "else", "do"]
        },
        LogicBoolean: {
            component: LogicBoolean,
            searchTags: ["compare", "logic", "comparison", "boolean", "bool", "1", "0", "true", "false"]
        },
        LogicCompareNew: {
            component: LogicCompareNew,
            searchTags: ["compare", "logic", "comparison", "greater", "lesser", "equals", "not"]
        },
        LogicNegate: {
            component: LogicNegate,
            searchTags: ["negate", "negative", "opposite", "flip", "rather", "otherwise", "not", "logic"]
        },
        LogicNull: {
            component: LogicNull,
            searchTags: ["logic", "null", "not", "empty", "undefined"]
        },
        LogicOperation: {
            component: LogicOperation,
            searchTags: ["boolean", "and", "or", "logic", "gates", "logic"]
        },
        SnapWait: {
            component: SnapWait,
            searchTags: ["wait", "hold", "delay", "pause", "after", "time", "later", "logic", "for", "then", "do"]
        }
    },
    "Loops": {
        ControlsRepeat: {
            component: ControlsRepeat,
            searchTags: ["repeat", "times", "for", "loops", "do", "iterate"]
        },
        ControlsWhileUntil: {
            component: ControlsWhileUntil,
            searchTags: ["repeat", "while", "until", "for", "do", "loops"]
        },
        CountWith: {
            component: CountWith,
            searchTags: ["count", "for", "loops", "numbers", "increment", "iterate", "with", "from", "by", "to", "until"]
        },
        ForEachItemInList: {
            component: ForEachItemInList,
            searchTags: ["for", "each", "item", "in", "iterate", "loops", "repeat", "list", "do"]
        },
        ControlsFlowStatements: {
            component: ControlsFlowStatements,
            searchTags: ["loops", "controls", "flow", "break", "exit", "out", "of", "continue", "with", "next", "iteration"]
        }
    },
    "Math": {
        MathNumber: {
            component: MathNumber,
            searchTags: ["math", "numbers", "1234567890"]
        },
        MathArithmetic: {
            component: MathArithmetic,
            searchTags: ["math", "arithmetic", "plus", "minus", "divide", "add", "subtract", "times", "multiply", "power", "raise", "exponent", "by", "over", "1234567890", "sum", "+", "-", "/", "*", "x", "^"]
        },
        MathSingle: {
            component: MathSingle,
            searchTags: ["math", "square", "root", "absolute", "negative", "-", "ln", "log", "exponent", "e", "^", "10", "sqrt", "1234567890"]
        },
        MathTrig: {
            component: MathTrig,
            searchTags: ["math", "trignometry", "sin", "cos", "tan", "asin", "acos", "atan", "1234567890"]
        },
        MathConstant: {
            component: MathConstant,
            searchTags: ["math", "constants", "sqrt", "pi", "epsilon", "phi", "square", "root", "infinity", "1234567890"]
        },
        MathNumberProperty: {
            component: MathNumberProperty,
            searchTags: ["math", "constant", "1234567890", "even", "odd", "prime", "whole", "positive", "negative", "divisible", "by", "is"]
        },
        MathToNumber: {
            component: MathToNumber,
            searchTags: ["math", "convert", "to", "number", "decimal", "decimals", "floating", "numbers", "1234567890"]
        },
        MathRound: {
            component: MathRound,
            searchTags: ["math", "round", "decimals", "floating", "numbers", "1234567890"]
        },
        MathOnList: {
            component: MathOnList,
            searchTags: ["math", "list", "sum", "min", "max", "average", "median", "modes", "sd", "standard", "deviation", "random", "item", "of"]
        },
        MathModulo: {
            component: MathModulo,
            searchTags: ["math", "modulo", "remainder", "1234567890", "/", "divided", "divisible", "of", "%"]
        },
        MathConstrain: {
            component: MathConstrain,
            searchTags: ["math", "constrain", "low", "high", "min", "max", "1234567890", "clip", "range"]
        },
        MathRandomInt: {
            component: MathRandomInt,
            searchTags: ["math", "random", "int", "low", "high", "min", "max", "1234567890", "range", "integer", "from", "to"]
        },
        MathRandomFloat: {
            component: MathRandomFloat,
            searchTags: ["math", "random", "float", "fraction", "decimal", "1234567890", ".", "numbers", "floating"]
        },
        RoundToDecimal: {
            component: RoundToDecimal,
            searchTags: ["math", "round", "to", "decimal", "round", "decimals", "floating", "numbers", "1234567890", "up", "down", "ceiling", "truncate", "floor"]
        }
    },
    "MobiControl": {
        MobiControlGetAndroidDeviceDetails: {
            component: MobiControlGetAndroidDeviceDetails,
            searchTags: ["mobicontrol", "mc", "device", "get", "android", "details", "custom", "attribute", "category", "group", "key", "value", "hardware", "configuration"]
        },
        MobiControlGetCustomAttribute: {
            component: MobiControlGetCustomAttribute,
            searchTags: ["mobicontrol", "mc", "device", "get", "custom", "attribute", "key", "value", "hardware", "configuration"]
        },
        MobiControlGetIsEnrolled: {
            component: MobiControlGetIsEnrolled,
            searchTags: ["mobicontrol", "mc", "device", "get", "is", "enrolled", "network", "value", "configuration"]
        },
        MobiControlGetDeviceId: {
            component: MobiControlGetDeviceId,
            searchTags: ["mobicontrol", "mc", "device", "get", "access", "id", "identification", "hardware", "value", "configuration"]
        },
        MobiControlGetIpAddress: {
            component: MobiControlGetIpAddress,
            searchTags: ["mobicontrol", "mc", "device", "get", "access", "ip", "address", "hardware", "network", "configuration"]
        },
        MobiControlGetMacAddress: {
            component: MobiControlGetMacAddress,
            searchTags: ["mobicontrol", "mc", "device", "get", "access", "mac", "address", "hardware", "network", "value", "configuration"]
        },
        MobiControlGetSerialNumber: {
            component: MobiControlGetSerialNumber,
            searchTags: ["mobicontrol", "mc", "device", "get", "access", "serial", "number", "hardware", "value", "configuration"]
        },
        MobiControlGetIosDeviceDetails: {
            component: MobiControlGetIosDeviceDetails,
            searchTags: ["mobicontrol", "mc", "device", "get", "ios", "apple", "details", "custom", "attribute", "key", "value", "hardware", "configuration"]
        }
    },
    "Repeater": {
        RepeaterNavigateFirst: {
            component: RepeaterNavigateFirst,
            searchTags: ["repeater", "navigate", "navigation", "first", "entry", "record", "item"]
        },
        RepeaterNavigateBack: {
            component: RepeaterNavigateBack,
            searchTags: ["repeater", "navigate", "navigation", "back", "prev", "previous", "entry", "record", "item"]
        },
        RepeaterNavigateNext: {
            component: RepeaterNavigateNext,
            searchTags: ["repeater", "navigate", "navigation", "forward", "next", "entry", "record", "item"]
        },
        RepeaterNavigateLast: {
            component: RepeaterNavigateLast,
            searchTags: ["repeater", "navigate", "navigation", "last", "entry", "record", "item"]
        },
        RepeaterNavigateTo: {
            component: RepeaterNavigateTo,
            searchTags: ["repeater", "navigate", "navigation", "to", "index", "page", "number", "entry", "record", "item"]
        },
        RepeaterEntryNew: {
            component: RepeaterEntryNew,
            searchTags: ["repeater", "create", "new", "empty", "entry", "record", "item"]
        },
        RepeaterEntryDelete: {
            component: RepeaterEntryDelete,
            searchTags: ["repeater", "delete", "remove", "confirm", "confirmation", "entry", "record", "item"]
        },
        RepeaterEntrySave: {
            component: RepeaterEntrySave,
            searchTags: ["repeater", "save", "add", "update", "validate", "submit", "entry", "record", "item"]
        },
        RepeaterEntriesAmount: {
            component: RepeaterEntriesAmount,
            searchTags: ["repeater", "get", "amount", "count", "length", "entries", "records", "items", "entry", "record", "item"]
        },
        RepeaterEntryIndex: {
            component: RepeaterEntryIndex,
            searchTags: ["repeater", "get", "index", "page", "current", "number", "position", "entry", "record", "item"]
        },
        RepeaterEntryValue: {
            component: RepeaterEntryValue,
            searchTags: ["repeater", "get", "widget", "value", "state", "current", "entry", "record", "item"]
        },
        RepeaterEntryIndexValue: {
            component: RepeaterEntryIndexValue,
            searchTags: ["repeater", "get", "widget", "value", "state", "index", "page", "position", "entry", "record", "item"]
        }
    },
    "Sound": {
        PlayNote: {
            component: PlayNote,
            searchTags: ["sound", "music", "play", "volume", "note"]
        },
        PlayBeep: {
            component: PlayBeep,
            searchTags: ["sound", "music", "play", "beep", "custom", "default", "effect", "volume", "second", "duration"]
        }
    },
    "Table": {
        SelectedRow: {
            component: SelectedRow,
            searchTags: ["Table", "TableView", "View", "selected", "get", "row", "data", "table", "column"]
        },
        AddRow: {
            component: AddRow,
            searchTags: ["Table", "TableView", "View", "add", "create", "row", "data", "table"]
        },        
        GetRecords: {
            component: GetRecords,
            searchTags: ["Table", "TableView", "View", "get", "records", "table"]
        },
        SetColumnName: {
            component: SetColumnName,
            searchTags: ["Table", "TableView", "View", "set", "column", "name", "rename", "table"]
        },
        GetColumn: {
            component: GetColumn,
            searchTags: ["Table", "TableView", "View", "get", "column", "records", "data", "table"]
        },
        DeleteRow: {
            component: DeleteRow,
            searchTags: ["Table", "TableView", "View", "delete", "row", "table"]
        },
        UpdateRow: {
            component: UpdateRow,
            searchTags: ["Table", "TableView", "View", "update", "value", "change", "edit", "row", "table"]
        },
        RefreshTable: {
            component: RefreshTable,
            searchTags: ["Table", "TableView", "View", "refresh", "table"]
        },
        RunEditRecords: {
            component: RunEditRecords,
            searchTags: ["Table", "TableView", "View", "run", "edit", "records"]
        },
        CancelEditRecords: {
            component: CancelEditRecords,
            searchTags: ["Table", "TableView", "View", "cancel", "edit", "records"]
        },
        ShowHideRow: {
            component: ShowHideRow,
            searchTags: ["Table", "TableView", "View", "show", "hide", "row", "table"]
        },
        LoadTableDataRest: {
            component: LoadTableDataRestV2,
            searchTags: ["Table", "TableView", "View", "get", "set", "post", "rest", "url", "response", "records", "data", "table"]
        }
    },
    "Text": {
        Text: {
            component: Text,
            searchTags: ["text", "string", "value", "placeholder"]
        },
        TextJoin: {
            component: TextJoin,
            searchTags: ["text", "string", "join", "create", "text", "with", "add", "remove", "subtract"]
        },
        TextAppend: {
            component: TextAppend,
            searchTags: ["to", "string", "item", "append", "text", "variable"]
        },
        TextLength: {
            component: TextLength,
            searchTags: ["text", "length", "string", "of"]
        },
        SOTISnackbar: {
            component: SotiSnackbar,
            searchTags: ['display', 'message', 'print', 'show', 'text', 'toast', 'snackbar', 'alert', 'prompt', 'error', "duration", "color", "colour", "background", "with", "animation", "fade", "in", "slide", "down", "up", "right", "to", "left"]
        },
        ShowMessage: {
            component: ShowMessage,
            searchTags: ['show', 'message', 'print', 'show', 'text', 'toast', 'alert', 'prompt', 'error', "duration", "color", "colour", "background", "with", "animation", "fade", "in", "slide", "down", "up", "right", "to", "left"]
        },
        ShowPrompt: {
            component: ShowPrompt,
            searchTags: ['show', 'message', 'print', 'show', 'text', 'toast', 'alert', 'prompt', 'error']
        },
        TextIsEmpty: {
            component: TextIsEmpty,
            searchTags: ["text", "string", "value", "is", "empty"]
        },
        Confirm: {
            component: Confirm,
            searchTags: ["confirmation", "message", "popup", "confirm", "text", "authentication", "alert", 'approval']
        },
        TextRegex: {
            component: TextRegex,
            searchTags: ["text", "string", "value", "is", "regular", "expresion", "regex", "validate", "test", "match", "against"]
        },
        TextIndexOf: {
            component: TextIndexOf,
            searchTags: ["text", "string", "index", "of", "in", "find", "first", "last", "#", "occurrence", "value"]
        },
        TextCharAt: {
            component: TextCharAt,
            searchTags: ["text", "in", "string", "get", "index", "first", "last", "#", "from", "end", "random", "letter"]
        },
        TextGetSubstring: {
            component: TextGetSubstring,
            searchTags: ["text", "in", "string", "get", "index", "first", "last", "#", "from", "end", "random", "letter", "substring", "to"]
        },
        TextChangeCase: {
            component: TextChangeCase,
            searchTags: ["text", "string", "to", "upper", "case", "lower", "title", "uppercase", "lowercase", "titlecase", "value"]
        },
        TextTrim: {
            component: TextTrim,
            searchTags: ["text", "string", "trim", "spaces", "from", "both", "left", "right", "sides", "in", "of", "value", "padding"]
        }
    },
    "XSight Topics": {
        SetXSightTopic: {
            component: SetXSightTopic,
            searchTags: ["set", "xsight", "topic"]
        },
        GetXSightTopic: {
            component: GetXSightTopic,
            searchTags: ["get", "xsight", "topic"]
        }
    }
};
